import * as React from 'react';
import { TilesIndex } from './tiles-index/tiles-index';
import { SelectItem, SelectType } from '../types';
import { useRef, useEffect, useState, JSX } from 'react';
import { IndexGroup } from 'ui/common/select/index-options/index-group';
import { getCharacterCategory } from 'app/infrastructure/platform/text';
import { KeepFocusOnElement } from 'ui/common/keep-focus-on-element';
import { IncludeDisabledCheckbox } from './include-disabled-checkbox';

export interface IndexOptionsProps {
  options: SelectItem[];
  valueItems: SelectItem[];
  selectType?: SelectType;
  onSelectOption: (item: SelectItem) => void;
  textPageOf?: string;
  includeDisabledCheckbox?: JSX.Element;
}

export const IndexOptions = ({
  options,
  valueItems,
  selectType,
  onSelectOption,
  textPageOf,
  includeDisabledCheckbox
}: IndexOptionsProps) => {

  const [activeGroup, setActiveGroup] = useState(undefined as string);

  const groupedCodes = useRef({} as Record<string, SelectItem[]>);
  const groupList = useRef([] as string[]);

  const selectedValues = valueItems?.map(i => i.value);

  useEffect(() => {

    groupList.current = [];

    groupedCodes.current = options.reduce((aggr, option): Record<string, SelectItem[]> => {
      const firstLetter =
        option && (getCharacterCategory(option.description) || '-');

      if (!groupList.current.includes(firstLetter)) {
        groupList.current.push(firstLetter);
      }

      if (!aggr[firstLetter]) {
        aggr[firstLetter] = [];
      }
      aggr[firstLetter].push(option);
      return aggr;
    }, {});

    const selectedOption = options?.find(o => selectedValues?.some(s => s === o.value));
    if (selectedValues?.length && selectedOption) {
      const optionGroup = getCharacterCategory(selectedOption.description) || '-';
      setActiveGroup(optionGroup);
    }
    else {
      setActiveGroup(groupList.current[0]);
    }
  }, [options]);

  return (
    <KeepFocusOnElement>
      <IncludeDisabledCheckbox includeDisabledCheckbox={includeDisabledCheckbox} />
      <TilesIndex
        groups={groupList.current}
        activeGroup={activeGroup}
        selectGroup={setActiveGroup}
      />
      <IndexGroup
        groupOptions={groupedCodes.current[activeGroup]}
        groupName={activeGroup}
        valueItems={valueItems}
        selectType={selectType}
        onSelectOption={onSelectOption}
        textPageOf={textPageOf}
      />
    </KeepFocusOnElement>
  );
};
